module.exports = __webpack_public_path__ + "img/Flat icon-52.87a72b7f.png";